// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FeedbackSchedule--next-sr-only--2B4Jqmz","filters":"FeedbackSchedule--filters--1pvD-cn","tabLabel":"FeedbackSchedule--tabLabel--2lNrlyR"};